import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * In-memory access-token holder. We deliberately do NOT use localStorage:
 *  - localStorage is readable by any script on the page, so an XSS would
 *    leak the token.
 *  - The backend already sets an httpOnly Secure cookie on login
 *    (`access_token`), which the browser sends automatically with
 *    `withCredentials: true`. That cookie is the source of truth for
 *    cross-page-load auth.
 *  - This in-memory copy is just used to attach a Bearer header in the
 *    same SPA session (useful for non-browser test clients and as a belt-
 *    and-suspenders fallback). It evaporates on page refresh, after which
 *    cookies still authenticate the user via `GET /auth/me`.
 */
let _accessToken = null;
export function setAccessToken(token) { _accessToken = token || null; }
export function clearAccessToken() { _accessToken = null; }
export function getAccessToken() { return _accessToken; }

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (_accessToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${_accessToken}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
